import { apiClient } from "../../../api/client";
import { ApiResponse } from "../../../types";
import {
  IndividualResult,
  LastStageFilter,
  OpsFilter,
  OverviewResult,
} from "../types";

export interface OverviewParams {
  dbName: string;
  ops: OpsFilter;
  date: string;
  /** Filtra pelo estágio em que a oferta parou ("all" = sem filtro) */
  lastStage?: LastStageFilter;
  page?: number;
  pageSize?: number;
}

export interface IndividualParams {
  dbName: string;
  ops?: string;
  cpf?: string;
  cnpj?: string;
  telefone?: string;
  /** YYYY-MM-DD — mostra ofertas a partir desta data (default backend: hoje - 7) */
  dataInicio?: string;
}

export const offerTrackingService = {
  async overview(params: OverviewParams): Promise<ApiResponse<OverviewResult>> {
    return apiClient.post("/gestorOfferTracking", { mode: "overview", ...params });
  },

  async individual(
    params: IndividualParams
  ): Promise<ApiResponse<IndividualResult>> {
    return apiClient.post("/gestorOfferTracking", {
      mode: "individual",
      ...params,
    });
  },
};
